import { RouterProvider, createBrowserRouter } from "react-router-dom";
import { routes } from "../helpers/Routes";
import Home from "../pages/Home";
import Productos from "../pages/Productos";
import Nosotros from "../pages/Nosotros";
import Contacto from "../pages/Contacto";
import FAQ from "../pages/FAQ";
import Producto from "../pages/Producto";
import Administracion from "../pages/Administracion";
import Login from "../pages/Login";
import { Suspense } from "react";
import { TailSpin } from "react-loader-spinner";
import ProtectedRoute from "../helpers/ProtectedRoute";
import { Check } from "@mui/icons-material";
import Checkout from "../pages/Checkout";
import Registro from "../pages/Registro";
import Pedidos from "../pages/Pedidos";
import Confirmation from "../pages/Confirmation";
import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import TerminosYCondiciones from "../pages/Terms";
import PaySuccess from "../pages/PaySuccess";
import CreateProduct from "../pages/CreateProduct";
import ScooterForm from "../components/ScooterForm";
// Importing the EditProduct component


import EditProduct from "../pages/EditProduct";
const FallbackLoader = () => {
    return (
        <div style={{
            display: "flex",
            height: "100vh",
            alignItems: "center",
            justifyContent: "center"

        }}>
            <TailSpin
                visible={true}
                height="80"
                width="80"
                color="#4fa94d"
                ariaLabel="tail-spin-loading"
                radius="1"
                wrapperStyle={{}}
                wrapperclassName=""
                contentLoader={(props) => (
                    <div>
                        <TailSpin {...props} />
                        <p style={{ marginTop: "10px", fontSize: "16px", fontWeight: "bold", color: "#4fa94d" }}>Cargando...</p>
                    </div>
                )}
            />
        </div>
    )
};

const router = createBrowserRouter([
    {
        path: '/administracion/create/',
        element: <Suspense fallback={<FallbackLoader />}><CreateProduct /></Suspense>
    },

    {
        path: '/administracion/create-scooter',
        element: <Suspense fallback={<FallbackLoader />}><ScooterForm create={true} /></Suspense>
    },
    {
        path: '/administracion/edit-scooter/:id',
        element: <Suspense fallback={<FallbackLoader />}><ScooterForm create={false} /></Suspense>
    },

    {
        path: '/administracion/edit/:id',
        element: <Suspense fallback={<FallbackLoader />}><EditProduct /></Suspense>
    },
    {
        path: '/',
        element: <Suspense fallback={<FallbackLoader />}><Home /></Suspense>
    },
    {
        path: '/terms',
        element: <Suspense fallback={<FallbackLoader />}><TerminosYCondiciones /></Suspense>
    },

    {
        path: routes.bicicletas,
        element: <Suspense fallback={<FallbackLoader />}><Productos /></Suspense>
    },
    {
        path: routes.nosotros,
        element: <Suspense fallback={<FallbackLoader />}><Nosotros /></Suspense>
    },
    {
        path: routes.contacto,
        element: <Suspense fallback={<FallbackLoader />}><Contacto /></Suspense>
    },
    {
        path: routes.faq,
        element: <Suspense fallback={<FallbackLoader />}><FAQ /></Suspense>
    },
    {
        path: routes.login,
        element: <Suspense fallback={<FallbackLoader />}><Login /></Suspense>
    },
    {
        path: routes.registro,
        element: <Suspense fallback={<FallbackLoader />}><Registro /></Suspense>
    },
    {
        path: routes.checkout,
        element: <Suspense fallback={<FallbackLoader />}><Checkout /></Suspense>
    },
    {
        path: routes.producto + "/:type" + "/:slug",
        element: <Suspense fallback={<FallbackLoader />}><Producto /></Suspense>
    },
    {
        path: '/',
        element: <ProtectedRoute />,
        children: [
            {
                path: routes.administracion + "/:id",
                element: <Suspense fallback={<FallbackLoader />}><Administracion /></Suspense>
            },
        ]
    },
    {
        path: '/',
        element: <ProtectedRoute />,
        children: [
            {
                path: routes.pedidos,
                element: <Suspense fallback={<FallbackLoader />}><Pedidos /></Suspense>
            },
        ]
    },
    {
        path: routes.confirmation + "/:norden",
        element: <Confirmation />
    },
    {
        path: routes.paySucess,
        element: <PaySuccess />
    }
]);

const Navigator = () => {
    return (
        <RouterProvider router={router} />
    );
}

export default Navigator;